import { createAction, props } from '@ngrx/store';
import { VehicleGroupApiModel } from 'app/models/vehicle-groups-api.model';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';

export const loadVehicleGroups = createAction(
  '[Vehicles groups] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadVehicleGroupsSuccess = createAction(
  '[Vehicles groups] Load Successful',
  props<{ response: MwPayloadModel<VehicleGroupApiModel[]> }>()
);

export const loadVehicleGroupsFailed = createAction(
  '[Vehicle groups] Load Failed',
  props<{ error: any }>()
);

export const createVehicleGroup = createAction(
  '[Vehicles groups] Create',
  props<{ vehicleGroup: VehicleGroupApiModel }>()
);

export const createVehicleGroupSuccess = createAction(
  '[Vehicles groups] Create Successful'
);

export const createVehicleGroupFailed = createAction(
  '[Vehicle groups] Create Failed',
  props<{ error: any }>()
);

export const updateVehicleGroup = createAction(
  '[Vehicles groups] Update',
  props<{ vehicleGroup: VehicleGroupApiModel }>()
);

export const updateVehicleGroupSuccess = createAction(
  '[Vehicles groups] Update Successful'
);

export const updateVehicleGroupFailed = createAction(
  '[Vehicle groups] Update Failed',
  props<{ error: any }>()
);

export const deleteVehicleGroup = createAction(
  '[Vehicles groups] Delete',
  props<{ vehicleGroup: VehicleGroupApiModel }>()
);

export const deleteVehicleGroupSuccess = createAction(
  '[Vehicles groups] Delete Successful'
);

export const deleteVehicleGroupFailed = createAction(
  '[Vehicle groups] Delete Failed',
  props<{ error: any }>()
);

export const deleteVehicleGroupsList = createAction(
  '[Vehicles groups] Delete List',
  props<{ vehicleGroups: VehicleGroupApiModel[] }>()
);

export const deleteVehicleGroupsListSuccess = createAction(
  '[Vehicles groups] Delete List Successful'
);

export const deleteVehicleGroupsListFailed = createAction(
  '[Vehicle groups] Delete List Failed',
  props<{ error: any }>()
);

export const resetVehicleGroups = createAction('[Vehicle groups] Reset');
